import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
//import CompanyHolidaysAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company-holidays/company-holidays.entity";
import { ICreateCompanyHoliday } from "./interface/create-company-holiday.interface";
import { IUpdateCompanyHoliday } from "./interface/update-company-holiday.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "company_holiday";

@Injectable({
  providedIn: "root",
})
export class CompanyHolidayService extends AbstractService<
any, //CompanyHolidaysAttributes //TODO HOLIDAYS
ICreateCompanyHoliday,
IUpdateCompanyHoliday
> {
  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findByCompanyId(companyId: string): Observable<IResult<any>> { //CompanyHolidaysAttributes //TODO HOLIDAYS
    const API_URL: string = `${apiUrl}api/${moduleName}/${companyId}`;
    return this.http.get<IResult<any>>(API_URL); //TODO HOLIDAYS
  }
}